import store from "@/store";
import axios from "axios";

// global variable
window.BASE_URL = "";
window.API_URL = window.BASE_URL + "/api";

// develop server url
// window.API_URL = "http://studio-active.treed.ai:8080/api";
// window.API_URL = "http://172.168.10.68:8080/api";
// window.API_URL = "https://studio.treed.ai/api";
// window.API_URL = "https://studio-dev.treed.ai/api";

function initCommonHeader(headers) {
  return {
    ...headers,
    Authorization: store.getters.auth.token,
  };
}

function codeInterceptor(res) {
  const code = res.data?.code || "";
  if (code === "") {
    return true;
  }

  switch (code) {
    case "C0001":
      return alertError(code, "요청 데이터 에러");
    case "C0002":
      return alertError(code, "서버 에러");
    case "W0001":
      return alertError(code, "작업 항목 정보 없음");
    case "CM0001":
      return alertError(code, "코멘트 정보 없음");
    default:
      return true;
  }
}

function alertError(code, msg = "Error occurred.") {
  alert(`${code}: ${msg}`);
  return false;
}

export default async (
  method,
  url,
  params = {},
  options = {
    headers: {},
    cancelable: false,
    interceptor: true,
  },
  { responseType = "json", onUploadProgress } = {}
) => {
  // create cancel token
  const cancel = axios.CancelToken.source();

  const conf = {
    method: method,
    url: url,
    data: params,
    responseType,
    headers: {
      ...initCommonHeader(options.headers),
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Expose-Headers": [
        "Authorization",
        "Content-Disposition",
        "Content-Type",
      ],
    },
    onUploadProgress: onUploadProgress
      ? (e) => {
          const percentCompleted = ~~((e.loaded * 100) / e.total);
          onUploadProgress &&
            onUploadProgress(percentCompleted, e.loaded, e.total);
        }
      : undefined,
    cancelToken: cancel.token,
  };

  try {
    const response = await axios(conf);
    if (options.interceptor) {
      if (!codeInterceptor(response)) return false;
    }

    if (options.cancelable) {
      return { data: response, cancel: cancel.cancel };
    }
    return response;
  } catch (err) {
    return err;
  }
};
